import React from 'react';
import { AccordionIconPosition, AccordionItem } from 'react-magma-dom';
import ReactMarkdown from 'react-markdown';
import { LessonNavItem } from '../../../types/lessons';
import {
  StyledAccordion,
  StyledAccordionButton,
  StyledAccordionPanel,
  StyledAccordionLink,
  StyledLessonSideNav,
} from '../../Styled';

interface ISideNav {
  navItems: LessonNavItem[];
  activeItemId?: number;
}

export const LessonSideNav: React.FC<ISideNav> = props => {
  const { navItems, activeItemId } = props;

  const expandedIndex = navItems.findIndex(({ items }) => items.find(({ id }) => id === activeItemId));
  return (
    <StyledLessonSideNav data-testid="lesson-side-nav">
      <StyledAccordion isMulti={false} iconPosition={AccordionIconPosition.none} defaultIndex={expandedIndex}>
        {navItems.map(({ title, items }) => (
          <AccordionItem key={title}>
            <StyledAccordionButton>{title}</StyledAccordionButton>
            <StyledAccordionPanel>
              {items.map((subItem, index) => (
                <AccordionItem key={`${index}-${subItem.title}`} index={index}>
                  <StyledAccordionLink
                    className={subItem.id === activeItemId ? 'active' : undefined}
                    to={`?page=${subItem.id}`}
                  >
                    <ReactMarkdown skipHtml={false}>{subItem.title}</ReactMarkdown>
                  </StyledAccordionLink>
                </AccordionItem>
              ))}
            </StyledAccordionPanel>
          </AccordionItem>
        ))}
      </StyledAccordion>
    </StyledLessonSideNav>
  );
};
